"use strict";
require('documenteditor/documenteditor');
require('common/directives/paginationDirective');
require('common/filters');
var detailsCtrl = require('thesaurus/controllers/detailsCtrl');
var editCtrl = require('thesaurus/controllers/editCtrl');
var indexCtrl = require('thesaurus/controllers/indexCtrl');
var navCtrl = require('common/controllers/navCtrl');
var app = angular.module('thesaurus', ['documenteditor', 'paginationDirective', 'templates', 'filters']);
app.controller('indexCtrl', ['$scope', '$rootScope', '$http', indexCtrl]);
app.controller('editCtrl', ['$scope', '$rootScope', '$http', 'name', 'id', 'permissions', '$uibModal', editCtrl]);
app.controller('detailsCtrl', detailsCtrl);
app.controller('navCtrl', ['$scope', navCtrl]);
module.exports = app;
